// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-progress-linear__background,.v-progress-linear__bar__determinate{border-radius:28px}", ""]);
// Exports
module.exports = exports;
